const iViewTemplateTransforms: Record<string, string> = {
  'pdmain': 'pdmainhawesko',
  'pdmain_mobile': 'pdmainhawesko_mobile',
  'pdmain_webp': 'pdmainhawesko_webp',
  'pdmain_mobile_webp': 'pdmainhawesko_mobile_webp',
  'pdmain_retina': 'pdmainhawesko_retina',
  'pdmain_retina_mobile': 'pdmainhawesko_retina_mobile',
  'pdmain_retina_webp': 'pdmainhawesko_retina_webp',
  'pdmain_retina_mobile_webp': 'pdmainhawesko_retina_mobile_webp',
};

function transformIViewTemplates(input: string, transformsMap: Record<string, string> = iViewTemplateTransforms) {
  let output: string;
  for (let key in transformsMap) {
    output = input.replace(`/${key}/`, `/${transformsMap[key]}/`);
    if (output !== input) {
      return output;
    }
  }

  return input;
}

export {
  transformIViewTemplates
}

